import {
  getData,
  getDataByToken,
  postData,
  convertPageModel
} from './api-base.service'

export const userLogin = (name, password, loginType) => {
  let data = {
    UserName: name,
    Password: password,
    LoginType: loginType
  };
  var result = postData('/User/Login', data, false);
  return result;
}

export const userRegister = (phone, code, universityId, firstName, lastName, email, password, confirmPassword, needlessSMSCode, channelId, isStudyAbroad) => {
  if ( channelId== ""){
    channelId = null;
  }
  let data = {
    Phone: phone,
    SMSCode: code,
    UniversityId: universityId,
    FirstName: firstName,
    LastName: lastName,
    Name: name,
    Email: email,
    Password: password,
    ConfirmPassword: confirmPassword,
    IsStudyAbroad: isStudyAbroad,
    ChannelId: channelId,
    NeedlessSMSCode: !!needlessSMSCode
  };
  return postData('/User/Register', data, false);
}


export const validateToken = (token) => {
  if (!!token){
    return getDataByToken('/User/ValidateToken', {}, token);
  }else{
    return getData('/User/ValidateToken');
  }
}

export const resetPassword = (form, resetType) => {
  let userId = 0;
  if (form.userId) {
    userId = form.userId;
  }
  if (typeof resetType == "undefined"){
    resetType = 1;
  }

  let data = {
    Id: userId,
    PasswordResetType: resetType,
    Password: form.password,
    ConfirmPassword: form.confirmPassword
  };

  if (resetType == 2){
    data.Id = form.studentId;
  }

  var result = postData('/User/ResetPassword', data);
  return result;
}

export const getEmployees = (roleList, keyword, sortList, enableOnly) => {
  if (typeof enableOnly ==  'undefined' ){
    enableOnly = false
  }
  let data = {
    RoleList: roleList,
    Keyword: keyword,
    SortList: sortList,
    EnableOnly: !!enableOnly
  };
  var result = postData('/User/GetEmployees', data);
  return result;
}

export const saveEmployee = (id, roleId, name, phone, password, isActive, universityGroupList, trainingCategoryIdList, channelIdList) => {
  if (typeof id == 'undefined' || id == null || id == "") {
    id = 0;
  }
  let data = {
    Id: id,
    RoleId: roleId,
    Name: name,
    Phone: phone,
    Password: password,
    IsActive: isActive,
    UniversityGroupList: universityGroupList,
    TrainingCategoryIdList: trainingCategoryIdList,
    ChannelIdList: channelIdList
  };
  var result = postData('/User/SaveEmployee', data);
  return result;
}

export const getUserActions = (model) => {
  let data = convertPageModel(model);
  var result = postData('/User/GetUserActions', data);
  return result;
}

export const getWechatUserInfo = (code) => {
  let data = {
    code: code,
  }
  var result = getData('/User/GetWechatUserInfo', data);
  return result;
}

export const bindWechat = (unionid, nickname) => {
  let data = {
    unionid: unionid,
    nickname: nickname
  }
  var result = getData('/User/BindWechat', data);
  return result;
}

export const validateWechatUser = (code) => {
  let data = {
    code: code,
  }
  return getData('/User/ValidateWechatUser', data);
}

export const checkUserCourseType = (checkReviewCourse) => {
  if (typeof checkReviewCourse == undefined){
    checkReviewCourse = false;
  }
  let result = getData("/User/CheckUserCourseType", {checkReviewCourse: checkReviewCourse});
  return result;
}

export const removeWechat = (studentId) => {
  let result = getData("/User/RemoveWechat", {studentId: studentId});
  return result;
}


// WEBPACK FOOTER //
// ./src/service/user.service.js